export const PLUCategoryItemHeight = 60;
